import { Component } from '@angular/core';

@Component({
    selector: 'key-listing-stat',
    templateUrl: './listing-stat.component.html',
    standalone: false
})
export class KeyListingStatComponent {
}
